import { CustomQuestionFieldType } from 'src/graphql/types/customQuestions'

export const SHORT_TEXT_MAX_LENGTH = 500

export type QuestionValues = Record<string, unknown>

export const questionValuesFromResponses = (responses): QuestionValues => {
  const values: QuestionValues = {}
  ;(responses ?? []).forEach((response) => {
    const id = response.applicationQuestionResponseId
    const fieldType = response.templateQuestion.question.fieldType
    if (
      fieldType === CustomQuestionFieldType.SHORT_TEXT ||
      fieldType === CustomQuestionFieldType.LONG_TEXT
    ) {
      values[id] = response.valueShortText || response.valueLongText || ''
    } else if (fieldType === CustomQuestionFieldType.BOOLEAN) {
      values[id] =
        response.valueBoolean !== null && response.valueBoolean !== undefined
          ? response.valueBoolean.toString()
          : undefined
    } else if (fieldType === CustomQuestionFieldType.SINGLE_SELECT) {
      values[id] =
        response.selectedOptions && response.selectedOptions.length > 0
          ? response.selectedOptions[0].customQuestionOptionId
          : ''
    } else if (fieldType === CustomQuestionFieldType.MULTI_SELECT) {
      values[id] =
        response.selectedOptions && response.selectedOptions.length > 0
          ? response.selectedOptions.map(
              (option) => option.customQuestionOptionId
            )
          : []
    }
  })
  return values
}

export const validateQuestionValues = (
  responses,
  values: QuestionValues
): Record<string, string> => {
  const errors: Record<string, string> = {}

  ;(responses ?? []).forEach((response) => {
    const id = response.applicationQuestionResponseId
    const value = values[id]
    const text = typeof value === 'string' ? value : ''
    const list = Array.isArray(value) ? value : []
    const isRequired = response.templateQuestion.isRequired
    const fieldType = response.templateQuestion.question.fieldType

    if (isRequired) {
      if (
        fieldType === CustomQuestionFieldType.SHORT_TEXT ||
        fieldType === CustomQuestionFieldType.LONG_TEXT
      ) {
        if (text.trim() === '') {
          errors[id] = 'This question is required'
        }
      } else if (fieldType === CustomQuestionFieldType.BOOLEAN) {
        if (value === undefined || value === null) {
          errors[id] = 'This question is required'
        }
      } else if (fieldType === CustomQuestionFieldType.SINGLE_SELECT) {
        if (text === '') {
          errors[id] = 'Please select an option'
        }
      } else if (fieldType === CustomQuestionFieldType.MULTI_SELECT) {
        if (list.length === 0) {
          errors[id] = 'Please select at least one option'
        }
      }
    }

    if (
      fieldType === CustomQuestionFieldType.SHORT_TEXT &&
      text.length > SHORT_TEXT_MAX_LENGTH
    ) {
      errors[id] = `Maximum ${SHORT_TEXT_MAX_LENGTH} characters allowed`
    }
  })

  return errors
}
